import { Button } from '@mui/material';
import { FunctionComponent } from 'react';

export const PrintButton: FunctionComponent = () => {
	function handlePrint() {
		window.print();
	}

	return <Button variant="contained" size='small' onClick={handlePrint}
		sx={{
			height: '2rem',
			display: 'flex',
			justifyContent: 'center',
			marginBottom: 4,
			'@media print': {
				display: 'none',
			},
		}}>
		Print
	</Button>;
};